// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* search style */

.admin-dash-search-dropdown {
  position: absolute;
  top: 55px;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, .15);
  z-index: 999;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
}

.search-item:hover {
  background: #f5f5f5;
}

.search-item img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  object-fit: cover;
}

.search-empty,
.search-loading {
  padding: 12px;
  text-align: center;
  color: #999;
}


/* end search style */


/* Close icon style */

.admin-dash-navbar-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-clear-icon {
  cursor: pointer;
  color: #888;
  font-size: 14px;
}

.search-clear-icon:hover {
  color: #000;
}


/* end close icon style */




/* .admin-dash-navbar {
    height: 64px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    position: relative;
  } */

.admin-dash-navbar {
  height: 64px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}


/* LEFT */
.admin-dash-navbar-left {
  display: flex;
  align-items: center;
  gap: 5px;
}

.admin-dash-navbar-logo {
  /* height: 36px; */
  cursor: pointer;
}

.admin-dash-navbar-search {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0f2f5;
  padding: 6px 4px;
  border-radius: 20px;
}

.admin-dash-navbar-search input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
}

/* CENTER */
/* .admin-dash-navbar-center {
    display: flex;
    gap: 40px;
  } */

.admin-dash-navbar-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 40px;
}


.admin-dash-nav-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #65676b;
}

.admin-dash-nav-icon.active,
.admin-dash-nav-icon:hover {
  color: var(--primary-100);
}

.admin-dash-nav-icon span {
  font-size: 12px;
}

/* RIGHT */
.admin-dash-navbar-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.admin-dash-icon-wrapper {
  position: relative;
  cursor: pointer;
}

.admin-dash-icon-wrapper svg {
  font-size: 20px;
}

.admin-dash-profile-pic {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

/* DROPDOWNS */
.admin-dash-dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  background: white;
  width: 260px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  padding: 10px;
  z-index: 100;
}

.admin-dash-notifications ul {
  list-style: none;
  padding: 0;
}

.admin-dash-notifications li {
  padding: 8px;
  border-radius: 6px;
}

.admin-dash-notifications li:hover {
  background: #f0f2f5;
}

/* PROFILE MENU */
.admin-dash-profile-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-bottom: 1px solid #eee;
}


.admin-dash-profile-header img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.admin-dash-profile-item {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.admin-dash-profile-item:hover {
  background: #f0f2f5;
}

.admin-dash-logout {
  color: #d32f2f;
}



/* responsive */

.mobile-bottom-nav {
  display: none;
}

.native-topbar,
.native-create-overlay,
.native-section-back {
  display: none;
}

.dashboard-tab-panel:not(.active) {
  display: none;
}

/* Actions introduced for the native app must not alter the legacy web dock. */
.mobile-bottom-nav .mobile-native-only {
  display: none;
}

/* Labels belong to the native application redesign, not the legacy web dock. */
html:not(.native-app) .mobile-bottom-nav > div > span {
  display: none;
}

@media (max-width: 944px) {

  /* TOP NAVBAR FIXED */
  .admin-dash-navbar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    flex: 1 1;
    min-width: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .admin-dash-navbar-left {
    flex: 1 1;
    min-width: 0;
  }

  .admin-dash-navbar-search {
    flex: 1 1;
    min-width: 0;
  }

  .admin-dash-navbar-search input {
    width: 100%;
    min-width: 0;
  }

  .admin-dash-navbar-right {
    flex-shrink: 0;
    gap: 12px;
  }

  /* CACHER LE CENTRE EN MOBILE */
  .admin-dash-navbar-center {
    display: none;
  }

  /* MOBILE BOTTOM NAV */
  .mobile-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-top: 1px solid #ddd;
    z-index: 1000;
  }

  .mobile-bottom-nav div {
    font-size: 22px;
    color: #65676b;
    cursor: pointer;
  }

  .mobile-bottom-nav div.active {
    color: var(--primary-200);
  }

}



/* Notifs */


.notif-overlay {
  position: fixed;
  inset: 0;
  background: rgba(20, 48, 67, .2);
  opacity: 0;
  visibility: hidden;
  transition: opacity .28s ease, visibility .28s ease;
  z-index: 1200;
}

.notif-overlay.show {
  opacity: 1;
  visibility: visible;
}

.notif-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: min(420px, 100vw);
  max-width: 100%;
  height: 100dvh;
  background: #fbfcfd;
  z-index: 1201;

  transform: translateX(100%);
  transition: transform .36s cubic-bezier(.2, .8, .2, 1), visibility .36s;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  border-left: 1px solid rgba(78, 119, 153, .24);
  box-shadow: -24px 0 60px rgba(16, 42, 61, .2), inset 1px 0 rgba(255, 255, 255, .86);
}

.notif-drawer.open {
  transform: translateX(0);
}

.notif-drawer:not(.open) {
  visibility: hidden;
  pointer-events: none;
  box-shadow: none;
}

.notif-drawer.open {
  visibility: visible;
  pointer-events: auto;
}

.notif-header {
  position: relative;
  padding: 25px 24px 20px;
  border-bottom: 1px solid rgba(78, 119, 153, .14);

  display: flex;
  justify-content: space-between;
  align-items: center;

  top: 0;
  background: #ffffff;
  z-index: 5;
  flex-shrink: 0;
}

.notif-header h3 {
  margin: 0;
  color: #193850;
  font-size: 1.25rem;
  font-weight: 850;
  letter-spacing: -.025em;
}

.notif-header p {
  margin: 5px 0 0;
  color: #71899b;
  font-size: .76rem;
  font-weight: 600;
}

.notif-close {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #4e7799;
  border: 1px solid #dce8ee;
  border-radius: 12px;
  cursor: pointer;
  background: #f6fafc;
  font-size: .95rem;
  transition: .2s ease;
}

.notif-close:hover {
  color: #e95a13;
  border-color: #ffd1ba;
  background: #fff3ec;
  transform: rotate(90deg);
}

.notif-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 18px 28px;
  -webkit-overflow-scrolling: touch;
  margin: 0;
}

.notif-card {
  position: relative;
  overflow: hidden;
  padding: 16px 42px 15px 17px;
  margin-bottom: 10px;
  border: 1px solid #dce8ee;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(30, 63, 88, .045);
  transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease, background-color .2s ease;
  cursor: pointer;
}

.notif-card::before {
  position: absolute;
  top: 13px;
  bottom: 13px;
  left: 0;
  width: 3px;
  content: "";
  border-radius: 0 999px 999px 0;
  background: #94a9ba;
}

.notif-card:hover {
  transform: translateX(-3px);
  border-color: #b8cfdd;
  background: #fbfdfe;
  box-shadow: 0 12px 24px rgba(30, 63, 88, .1);
}

.notif-card strong {
  display: block;
  margin-bottom: 5px;
  overflow: hidden;
  color: #29475e;
  font-size: .86rem;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notif-card p {
  margin: 0;
  color: #607b91;
  font-size: .76rem;
  font-weight: 600;
  line-height: 1.45;
}

.notif-card small {
  display: block;
  margin-top: 8px;
  color: #94a9ba;
  font-size: .66rem;
  font-weight: 650;
}

.notif-dot {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e95a13;
  box-shadow: 0 0 0 4px #fff1e9;
}

.notif-card.unread {
  border-color: #bed9ea;
  background: #f8fcfe;
}

.notif-card.unread::before {
  background: #e95a13;
}

@media(max-width:768px) {
  .notif-drawer {
    width: 100%;
  }

  .notif-header {
    padding: 22px 18px 17px;
  }

  .notif-list {
    padding: 14px 14px calc(88px + env(safe-area-inset-bottom));
  }
}

.notif-bell-wrap {
  position: relative;
}

.notif-badge {
  position: absolute;
  top: -8px;
  right: -10px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 30px;
  background: #ef4444;
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(239, 68, 68, .35);
}


.notif-clickable {
  cursor: pointer;
  transition: .2s;
}

.notif-clickable:hover {
  color: var(--primary-200);
}


.notif-skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.notif-skeleton-item {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 12px;
}

.notif-sk-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  flex-shrink: 0;
}

.notif-sk-content {
  flex: 1 1;
}

.notif-sk-line {
  width: 100%;
  height: 14px;
  border-radius: 20px;
  margin-bottom: 10px;
}

.notif-sk-line.short {
  width: 55%;
}

.notif-follow-back-btn {
  margin-top: 10px;
  border: 1px solid #e95a13;
  border-radius: 9px;
  padding: 7px 12px;
  background: #e95a13;
  color: white;
  font-size: .7rem;
  font-weight: 800;
  cursor: pointer;
}

.notif-follow-back-btn:hover {
  opacity: .92;
}

/* High-tech CarrerUp application dock */
.admin-dash-navbar {
  left: 50%;
  width: min(1440px, calc(100% - 36px));
  height: 70px;
  padding: 0 18px;
  transform: translateX(-50%);
  background: rgba(250, 252, 253, .84);
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 18px;
  box-shadow: 0 16px 38px rgba(30, 63, 88, .11), inset 0 1px rgba(255, 255, 255, .9);
  backdrop-filter: blur(18px);
}

.admin-dash-navbar::before {
  content: "";
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: -1px;
  height: 1px;
  background: rgba(233, 90, 19, .25);
}

.admin-dash-navbar-left {
  gap: 12px;
  min-width: 330px;
}

.admin-dash-navbar-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.admin-dash-navbar-search {
  width: min(300px, 24vw);
  gap: 10px;
  padding: 8px 12px;
  background: rgba(241, 246, 249, .86);
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 12px;
  transition: .2s;
}

.admin-dash-navbar-search:focus-within {
  width: min(345px, 28vw);
  background: #fff;
  border-color: rgba(233, 90, 19, .55);
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .08);
}

.admin-dash-navbar-search input {
  width: 100%;
  color: #1d394f;
  font-size: .84rem;
}

.admin-dash-navbar-search input::placeholder {
  color: #7890a2;
}

.search-clear-icon {
  color: #e95a13;
}

.admin-dash-search-dropdown {
  top: 51px;
  background: rgba(255, 255, 255, .98);
  border: 1px solid #e1e9ee;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(30, 63, 88, .15);
  overflow: hidden;
}

.search-item {
  padding: 12px;
}

.search-item:hover {
  background: #fff2eb;
}

.admin-dash-navbar-center {
  gap: 9px;
  padding: 5px;
  background: rgba(232, 239, 244, .56);
  border: 1px solid rgba(78, 119, 153, .1);
  border-radius: 15px;
}

.admin-dash-nav-icon {
  min-width: 66px;
  padding: 7px 8px;
  border-radius: 11px;
  color: #71899b;
  transition: .2s;
}

.admin-dash-nav-icon svg {
  font-size: 18px;
  color: #e95a13;

}

.admin-dash-nav-icon span {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 650;
}

.admin-dash-nav-icon:hover {
  color: #e95a13;
  background: rgba(255, 255, 255, .84);
}

.admin-dash-nav-icon.active {
  color: #e95a13;
  background: #fff;
  box-shadow: 0 4px 12px rgba(30, 63, 88, .1);
}

.admin-dash-navbar-right {
  gap: 10px;
}

.admin-dash-icon-wrapper {
  display: grid;
  place-items: center;
  min-width: 40px;
  min-height: 40px;
  border: 1px solid rgba(78, 119, 153, .14);
  border-radius: 12px;
  background: rgba(255, 255, 255, .6);
}

.admin-dash-icon-wrapper:hover {
  border-color: rgba(233, 90, 19, .42);
  background: #fff3ec;
}

.admin-dash-profile-pic {
  width: 38px;
  height: 38px;
  border: 2px solid #fff;
  box-shadow: 0 3px 10px rgba(30, 63, 88, .13);
}

.notif-badge {
  background: #e95a13;
}

@media(max-width:944px) {
  .admin-dash-navbar {
    left: 10px;
    right: 10px;
    width: calc(100% - 20px);
    transform: none !important;
  }

}

@media(max-width:768px) {
  .admin-dash-navbar {
    top: 8px;
    right: 10px;
    left: 10px;
    width: calc(100% - 20px);
    height: 62px;
    padding: 0 10px;
    border-radius: 15px;
    gap: 8px;
    transform: none;
  }

  .admin-dash-navbar-left {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    gap: 8px;
  }

  .admin-dash-navbar-logo {
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
  }

  .admin-dash-navbar-search {
    display: flex;
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    padding: 7px 9px;
  }

  .admin-dash-navbar-search:focus-within {
    width: auto;
  }

  .admin-dash-navbar-search input {
    min-width: 0;
    font-size: .78rem;
  }

  .admin-dash-navbar-center {
    display: none;
  }

  .admin-dash-navbar-right {
    display: flex;
    flex: 0 0 auto;
    gap: 5px;
  }

  .admin-dash-icon-wrapper {
    display: grid;
    place-items: center;
    min-width: 35px;
    min-height: 35px;
    border-radius: 10px;
  }

  .mobile-bottom-nav {
    display: flex;
    position: fixed;
    top: auto;
    right: 10px;
    bottom: 10px;
    left: 10px;
    width: calc(100% - 20px);
    height: 62px;
    padding: 0 10px;
    background: rgba(250, 252, 253, .9);
    border: 1px solid rgba(78, 119, 153, .17);
    border-radius: 17px;
    box-shadow: 0 12px 30px rgba(30, 63, 88, .14);
    backdrop-filter: blur(18px);
  }

  .mobile-bottom-nav div {
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    color: #71899b;
    transition: .2s ease;
  }

  .mobile-bottom-nav div.active {
    color: #e95a13;
    background: #fff3ec;
    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);
  }
}

/* The mobile dock lives inside the navbar in the current JSX structure. */
/* @media (max-width: 944px) {
  .admin-dash-navbar .mobile-bottom-nav {
    position: absolute !important;
    top: calc(100vh - 80px) !important;
    right: auto !important;
    bottom: auto !important;
    left: 0 !important;
    width: calc(100vw - 20px) !important;
  }
} */

/* One consistent compact layout for phones and small tablets. */
@media (max-width: 944px) {

  .mobile-bottom-nav {
    display: flex;
    position: fixed;
    top: auto;
    right: 10px;
    bottom: 10px;
    left: 10px;
    width: calc(100% - 20px);
    height: 62px;
    padding: 0 10px;
    background: rgba(250, 252, 253, .9);
    border: 1px solid rgba(78, 119, 153, .17);
    border-radius: 17px;
    box-shadow: 0 12px 30px rgba(30, 63, 88, .14);
    backdrop-filter: blur(18px);
  }

  .mobile-bottom-nav div {
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    color: #71899b;
    transition: .2s ease;
  }

  .mobile-bottom-nav div.active {
    color: #e95a13;
    background: #fff3ec;
    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);
  }

  .admin-dash-navbar {
    top: 8px;
    right: 10px;
    left: 10px;
    box-sizing: border-box;
    width: auto;
    height: 62px;
    padding: 0 10px;
    border-radius: 15px;
    gap: 8px;
  }

  .admin-dash-navbar-left {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    gap: 8px;
  }

  .admin-dash-navbar-logo {
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
  }

  .admin-dash-navbar-search {
    display: flex;
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    padding: 7px 9px;
  }

  .admin-dash-navbar-search input {
    min-width: 0;
    font-size: .78rem;
  }

  .admin-dash-navbar-center {
    display: none;
  }

  .admin-dash-navbar-right {
    display: flex;
    flex: 0 0 auto;
    gap: 5px;
  }

  .admin-dash-icon-wrapper {
    display: grid;
    place-items: center;
    min-width: 35px;
    min-height: 35px;
    border-radius: 10px;
  }

  .admin-dash-navbar .mobile-bottom-nav {
    box-sizing: border-box;
  }
}

/* Premium profile menu */
.admin-dash-dropdown.admin-dash-profile-menu {
  top: calc(100% + 12px);
  right: 0;
  width: 286px;
  padding: 8px;
  overflow: hidden;
  background: rgba(250, 252, 253, .97);
  border: 1px solid rgba(78, 119, 153, .18);
  border-radius: 16px;
  box-shadow: 0 18px 42px rgba(30, 63, 88, .18), inset 0 1px rgba(255, 255, 255, .95);
  backdrop-filter: blur(18px);
  animation: profile-menu-in .2s ease-out;
}

.admin-dash-profile-menu .admin-dash-profile-header {
  position: relative;
  min-height: 60px;
  margin-bottom: 6px;
  padding: 10px;
  border: 1px solid rgba(78, 119, 153, .11);
  border-radius: 12px;
  background: rgba(241, 246, 249, .76);
  color: #1d394f;
  font-weight: 750;
}

.admin-dash-profile-menu .admin-dash-profile-header::after {
  content: "";
  position: absolute;
  top: 13px;
  left: 40px;
  width: 8px;
  height: 8px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #e95a13;
  box-shadow: 0 0 0 2px rgba(233, 90, 19, .14);
}

.admin-dash-profile-menu .admin-dash-profile-header img,
.admin-dash-profile-menu .admin-dash-profile-header>svg {
  display: grid;
  place-items: center;
  width: 36px !important;
  height: 36px !important;
  border: 2px solid #fff;
  border-radius: 11px !important;
  color: #4e7799;
  background: #e8eff4;
  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);
}

.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header) {
  min-height: 44px;
  margin: 2px 0;
  padding: 9px 10px;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #345269;
  font-size: .83rem;
  font-weight: 650;
  transition: .18s ease;
}

.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header) svg {
  display: grid;
  place-items: center;
  box-sizing: content-box;
  width: 17px;
  height: 17px;
  padding: 7px;
  border-radius: 9px;
  color: #4e7799;
  background: #edf3f6;
}

.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header):hover {
  border-color: rgba(233, 90, 19, .17);
  background: #fff3ec;
  color: #d84f0d;
  transform: translateX(3px);
}

.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header):hover svg {
  color: #e95a13;
  background: #ffe5d6;
}

.admin-dash-profile-menu .admin-dash-logout {
  margin-top: 7px;
  padding-top: 12px !important;
  border-top: 1px solid rgba(78, 119, 153, .12) !important;
  color: #bd3d25 !important;
}

.admin-dash-profile-menu .admin-dash-logout svg {
  color: #bd3d25 !important;
  background: #fff0ed !important;
}

@keyframes profile-menu-in {
  from {
    opacity: 0;
    transform: translateY(-7px) scale(.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 944px) {
  .admin-dash-dropdown.admin-dash-profile-menu {
    position: fixed;
    top: 78px;
    right: 10px;
    width: min(286px, calc(100vw - 20px));
  }
}

/* Glovo-inspired active navigation icon — final override for both nav variants. */
.admin-dash-nav-icon > svg {
  transform-origin: 48% 62%;
  transition: transform .28s cubic-bezier(.2,.8,.2,1), filter .28s ease, color .28s ease;
}

.admin-dash-nav-icon.active > svg {
  color: #e95a13;
  filter: drop-shadow(0 5px 7px rgba(233, 90, 19, .3));
  animation: navIconWow .72s cubic-bezier(.18,.89,.32,1.38) both;
}

.admin-dash-nav-icon.active::before {
  transform: rotate(-7deg);
  box-shadow: 0 9px 20px rgba(233,90,19,.25), inset 0 1px rgba(255,255,255,.35);
}

@media (max-width: 944px) {
  .mobile-bottom-nav {
    position: fixed !important;
    top: auto !important;
    right: 10px !important;
    left: 10px !important;
    width: auto !important;
    overflow: visible;
    bottom: calc(
      max(
        var(--mobile-browser-inset, 0px),
        env(safe-area-inset-bottom, 0px)
      ) + 10px
    ) !important;
  }

  .mobile-bottom-nav > div {
    position: relative;
    isolation: isolate;
    overflow: visible;
  }

  .mobile-bottom-nav > div::before {
    content: "";
    position: absolute;
    z-index: -1;
    width: 43px;
    height: 43px;
    border-radius: 14px 17px 13px 17px;
    opacity: 0;
    background: linear-gradient(145deg, #f57a3c, #e34e08);
    box-shadow: 0 11px 23px rgba(233,90,19,.3), inset 0 1px rgba(255,255,255,.42);
    transform: translateY(5px) rotate(0) scale(.55);
    transition: opacity .2s ease, transform .45s cubic-bezier(.16,1,.3,1);
  }

  .mobile-bottom-nav > div::after {
    content: "";
    position: absolute;
    z-index: -2;
    width: 50px;
    height: 50px;
    border: 1px solid rgba(233,90,19,.35);
    border-radius: 17px;
    opacity: 0;
    transform: scale(.65) rotate(-8deg);
  }

  .mobile-bottom-nav > div > svg {
    position: relative;
    z-index: 1;
    transform-origin: 48% 65%;
    transition: color .25s ease, transform .3s ease, filter .3s ease;
  }

  .mobile-bottom-nav > div.active {
    color: #fff !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .mobile-bottom-nav > div.active::before {
    opacity: 1;
    transform: translateY(-9px) rotate(-8deg) scale(1);
    animation: navBadgeFloat 3s ease-in-out .7s infinite;
  }

  .mobile-bottom-nav > div.active::after {
    animation: navActiveRipple .85s .12s cubic-bezier(.2,.7,.2,1) both;
  }

  .mobile-bottom-nav > div.active > svg {
    color: #fff;
    filter: drop-shadow(0 5px 7px rgba(125,41,4,.3));
    animation: navIconWow .72s cubic-bezier(.18,.89,.32,1.38) both;
  }

  .mobile-bottom-nav > div:not(.active):hover > svg {
    color: #e95a13;
    transform: translateY(-2px) rotate(-3deg);
  }
}

@keyframes navIconWow {
  0% { opacity: .35; transform: translateY(8px) rotate(16deg) scale(.58); }
  46% { transform: translateY(-13px) rotate(-14deg) scale(1.2); }
  72% { transform: translateY(-8px) rotate(-6deg) scale(.94); }
  100% { opacity: 1; transform: translateY(-9px) rotate(-9deg) scale(1.06); }
}

@keyframes navActiveRipple {
  0% { opacity: .75; transform: translateY(-9px) scale(.65) rotate(-8deg); }
  100% { opacity: 0; transform: translateY(-9px) scale(1.55) rotate(-2deg); }
}

@keyframes navBadgeFloat {
  0%, 100% { transform: translateY(-9px) rotate(-8deg); }
  50% { transform: translateY(-12px) rotate(-5deg); }
}

@media (prefers-reduced-motion: reduce) {
  .admin-dash-nav-icon.active > svg,
  .mobile-bottom-nav > div.active::before,
  .mobile-bottom-nav > div.active::after,
  .mobile-bottom-nav > div.active > svg {
    animation: none !important;
  }
}

/* Feed user search: premium discovery list. */
.admin-dash-navbar-search .admin-dash-search-dropdown {
  top: calc(100% + 10px);
  left: 0;
  width: min(420px, calc(100vw - 48px));
  max-height: min(420px, calc(100dvh - 120px));
  padding: 7px;
  overflow-y: auto;
  border: 1px solid rgba(78, 119, 153, .18);
  border-radius: 16px;
  background: #fbfcfd;
  box-shadow: 0 20px 44px rgba(30, 63, 88, .18), inset 0 1px #ffffff;
  scrollbar-width: thin;
  scrollbar-color: #94a9ba transparent;
  animation: feed-user-search-in .2s ease both;
}

.admin-dash-navbar-search .admin-dash-search-dropdown::before {
  content: "";
  position: absolute;
  top: 0;
  right: 22px;
  left: 22px;
  height: 2px;
  border-radius: 0 0 3px 3px;
  background: #e95a13;
}

.admin-dash-navbar-search .search-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 60px;
  gap: 10px;
  margin: 0;
  padding: 9px;
  border: 1px solid transparent;
  border-radius: 11px;
  color: #29475e;
  background: transparent;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  text-align: left;
  cursor: pointer;
  transition: .18s ease;
}

.admin-dash-navbar-search .search-item:hover {
  border-color: rgba(233, 90, 19, .2);
  background: #fff8f4;
  transform: translateX(2px);
}

.search-item-avatar {
  display: grid;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  place-items: center;
  overflow: hidden;
  border: 2px solid #ffffff;
  border-radius: 12px;
  color: #ffffff;
  background: #4e7799;
  box-shadow: 0 4px 10px rgba(78, 119, 153, .18);
}

.search-item-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 9px;
  object-fit: cover;
}

.search-item-avatar svg {
  font-size: .9rem;
}

.search-item-content {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 2px;
}

.search-item-content strong {
  overflow: hidden;
  color: #29475e;
  font-size: .78rem;
  font-weight: 850;
  letter-spacing: -.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-item-content small {
  overflow: hidden;
  color: #71899b;
  font-size: .66rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.search-item-arrow {
  flex: 0 0 auto;
  color: #94a9ba;
  font-size: .72rem;
  transition: .18s ease;
}

.search-item:hover .search-item-arrow {
  color: #e95a13;
  transform: translateX(2px);
}

.admin-dash-navbar-search .search-empty,
.admin-dash-navbar-search .search-loading {
  margin: 0;
  padding: 20px 12px;
  color: #71899b;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: .73rem;
  font-weight: 700;
  text-align: center;
}

.admin-dash-navbar-search .search-loading::before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 50%;
  background: #e95a13;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .12);
  animation: feed-search-pulse 1s ease-in-out infinite alternate;
}

.admin-dash-navbar-search .search-empty {
  border: 1px dashed rgba(78, 119, 153, .2);
  border-radius: 10px;
}

.admin-dash-navbar-search .search-item:focus-visible {
  outline: 2px solid #e95a13;
  outline-offset: 2px;
}

@keyframes feed-user-search-in {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(.985);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes feed-search-pulse {
  from {
    opacity: .5;
  }

  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .admin-dash-navbar-search .admin-dash-search-dropdown {
    position: fixed;
    top: 78px;
    right: 10px;
    left: 10px;
    width: auto;
    max-height: min(430px, calc(100dvh - 168px));
    border-radius: 15px;
  }

  .admin-dash-navbar-search .search-item {
    min-height: 58px;
  }
}


.admin-dash-subscription {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 12px 14px;
  margin: 6px 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.2s ease;
}

.admin-dash-subscription:hover {
  background: rgba(0, 0, 0, 0.04);
}

.subscription-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.admin-dash-subscription.free .subscription-icon {
  background: #f1f3f5;
  color: #606770;
}

.admin-dash-subscription.premium .subscription-icon {
  background: rgba(255, 183, 0, 0.12);
  color: #e6a400;
}

.subscription-info {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.subscription-info strong {
  font-size: 14px;
  font-weight: 700;
}

.subscription-info span {
  font-size: 11px;
  color: #777;
  margin-top: 2px;
}

.admin-dash-subscription.premium .subscription-info strong {
  color: #d99a00;
}

.subscription-arrow {
  font-size: 11px;
  color: #aaa;
}

.subscription-loading {
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/componentsL/Navbar.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;;AAGA,qBAAqB;;;AAGrB,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;;AAGA,yBAAyB;;;;;AAKzB;;;;;;;;;KASK;;AAEL;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;AACf;;;AAGA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,WAAW;AACX;;;KAGK;;AAEL;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;;AAIA,eAAe;;AAEf;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,8EAA8E;AAC9E;EACE,aAAa;AACf;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,SAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;;;;AAIA,WAAW;;;AAGX;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;;EAEb,2BAA2B;EAC3B,uEAAuE;;EAEvE,aAAa;EACb,sBAAsB;;EAEtB,gBAAgB;;EAEhB,8CAA8C;EAC9C,mFAAmF;AACrF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gDAAgD;;EAEhD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,qGAAqG;EACrG,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,OAAO;EACP,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;;AAGA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,kFAAkF;EAClF,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,0BAA0B;EAC5B;;AAEF;;AAEA;EACE;IACE,QAAQ;IACR,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,6CAA6C;IAC7C,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,kDAAkD;EACpD;AACF;;AAEA,0EAA0E;AAC1E;;;;;;;;;GASG;;AAEH,gEAAgE;AAChE;;EAEE;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,6CAA6C;IAC7C,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,kDAAkD;EACpD;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,mFAAmF;EACnF,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,qCAAqC;EACvC;AACF;;AAEA,kFAAkF;AAClF;EACE,yBAAyB;EACzB,sFAAsF;AACxF;;AAEA;EACE,cAAc;EACd,oDAAoD;EACpD,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;EACxB,6EAA6E;AAC/E;;AAEA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB;;;;;gBAKY;EACd;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,UAAU;IACV,qDAAqD;IACrD,6EAA6E;IAC7E,+CAA+C;IAC/C,qEAAqE;EACvE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,mBAAmB;IACnB,UAAU;IACV,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,gEAAgE;EAClE;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,kDAAkD;IAClD,oDAAoD;EACtD;;EAEA;IACE,kEAAkE;EACpE;;EAEA;IACE,WAAW;IACX,gDAAgD;IAChD,8DAA8D;EAChE;;EAEA;IACE,cAAc;IACd,yCAAyC;EAC3C;AACF;;AAEA;EACE,KAAK,YAAY,EAAE,mDAAmD,EAAE;EACxE,MAAM,sDAAsD,EAAE;EAC9D,MAAM,oDAAoD,EAAE;EAC5D,OAAO,UAAU,EAAE,qDAAqD,EAAE;AAC5E;;AAEA;EACE,KAAK,YAAY,EAAE,oDAAoD,EAAE;EACzE,OAAO,UAAU,EAAE,qDAAqD,EAAE;AAC5E;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,OAAO;EACP,qCAAqC;EACrC,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;EAClE,qBAAqB;EACrB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,oEAAoE;EACpE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,8DAA8D;AAChE;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,UAAU;IACV,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* search style */\n\n.admin-dash-search-dropdown {\n  position: absolute;\n  top: 55px;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, .15);\n  z-index: 999;\n}\n\n.search-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n.search-item:hover {\n  background: #f5f5f5;\n}\n\n.search-item img {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.search-empty,\n.search-loading {\n  padding: 12px;\n  text-align: center;\n  color: #999;\n}\n\n\n/* end search style */\n\n\n/* Close icon style */\n\n.admin-dash-navbar-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.search-clear-icon {\n  cursor: pointer;\n  color: #888;\n  font-size: 14px;\n}\n\n.search-clear-icon:hover {\n  color: #000;\n}\n\n\n/* end close icon style */\n\n\n\n\n/* .admin-dash-navbar {\n    height: 64px;\n    background: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n    position: relative;\n  } */\n\n.admin-dash-navbar {\n  height: 64px;\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1000;\n}\n\n\n/* LEFT */\n.admin-dash-navbar-left {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.admin-dash-navbar-logo {\n  /* height: 36px; */\n  cursor: pointer;\n}\n\n.admin-dash-navbar-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f0f2f5;\n  padding: 6px 4px;\n  border-radius: 20px;\n}\n\n.admin-dash-navbar-search input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 16px;\n}\n\n/* CENTER */\n/* .admin-dash-navbar-center {\n    display: flex;\n    gap: 40px;\n  } */\n\n.admin-dash-navbar-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 40px;\n}\n\n\n.admin-dash-nav-icon {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  color: #65676b;\n}\n\n.admin-dash-nav-icon.active,\n.admin-dash-nav-icon:hover {\n  color: var(--primary-100);\n}\n\n.admin-dash-nav-icon span {\n  font-size: 12px;\n}\n\n/* RIGHT */\n.admin-dash-navbar-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.admin-dash-icon-wrapper {\n  position: relative;\n  cursor: pointer;\n}\n\n.admin-dash-icon-wrapper svg {\n  font-size: 20px;\n}\n\n.admin-dash-profile-pic {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* DROPDOWNS */\n.admin-dash-dropdown {\n  position: absolute;\n  top: 50px;\n  right: 0;\n  background: white;\n  width: 260px;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  padding: 10px;\n  z-index: 100;\n}\n\n.admin-dash-notifications ul {\n  list-style: none;\n  padding: 0;\n}\n\n.admin-dash-notifications li {\n  padding: 8px;\n  border-radius: 6px;\n}\n\n.admin-dash-notifications li:hover {\n  background: #f0f2f5;\n}\n\n/* PROFILE MENU */\n.admin-dash-profile-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n\n.admin-dash-profile-header img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.admin-dash-profile-item {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.admin-dash-profile-item:hover {\n  background: #f0f2f5;\n}\n\n.admin-dash-logout {\n  color: #d32f2f;\n}\n\n\n\n/* responsive */\n\n.mobile-bottom-nav {\n  display: none;\n}\n\n.native-topbar,\n.native-create-overlay,\n.native-section-back {\n  display: none;\n}\n\n.dashboard-tab-panel:not(.active) {\n  display: none;\n}\n\n/* Actions introduced for the native app must not alter the legacy web dock. */\n.mobile-bottom-nav .mobile-native-only {\n  display: none;\n}\n\n/* Labels belong to the native application redesign, not the legacy web dock. */\nhtml:not(.native-app) .mobile-bottom-nav > div > span {\n  display: none;\n}\n\n@media (max-width: 944px) {\n\n  /* TOP NAVBAR FIXED */\n  .admin-dash-navbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .admin-dash-navbar-left {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .admin-dash-navbar-search {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .admin-dash-navbar-search input {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .admin-dash-navbar-right {\n    flex-shrink: 0;\n    gap: 12px;\n  }\n\n  /* CACHER LE CENTRE EN MOBILE */\n  .admin-dash-navbar-center {\n    display: none;\n  }\n\n  /* MOBILE BOTTOM NAV */\n  .mobile-bottom-nav {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    background: #fff;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    border-top: 1px solid #ddd;\n    z-index: 1000;\n  }\n\n  .mobile-bottom-nav div {\n    font-size: 22px;\n    color: #65676b;\n    cursor: pointer;\n  }\n\n  .mobile-bottom-nav div.active {\n    color: var(--primary-200);\n  }\n\n}\n\n\n\n/* Notifs */\n\n\n.notif-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 48, 67, .2);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity .28s ease, visibility .28s ease;\n  z-index: 1200;\n}\n\n.notif-overlay.show {\n  opacity: 1;\n  visibility: visible;\n}\n\n.notif-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: min(420px, 100vw);\n  max-width: 100%;\n  height: 100dvh;\n  background: #fbfcfd;\n  z-index: 1201;\n\n  transform: translateX(100%);\n  transition: transform .36s cubic-bezier(.2, .8, .2, 1), visibility .36s;\n\n  display: flex;\n  flex-direction: column;\n\n  overflow: hidden;\n\n  border-left: 1px solid rgba(78, 119, 153, .24);\n  box-shadow: -24px 0 60px rgba(16, 42, 61, .2), inset 1px 0 rgba(255, 255, 255, .86);\n}\n\n.notif-drawer.open {\n  transform: translateX(0);\n}\n\n.notif-drawer:not(.open) {\n  visibility: hidden;\n  pointer-events: none;\n  box-shadow: none;\n}\n\n.notif-drawer.open {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.notif-header {\n  position: relative;\n  padding: 25px 24px 20px;\n  border-bottom: 1px solid rgba(78, 119, 153, .14);\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  top: 0;\n  background: #ffffff;\n  z-index: 5;\n  flex-shrink: 0;\n}\n\n.notif-header h3 {\n  margin: 0;\n  color: #193850;\n  font-size: 1.25rem;\n  font-weight: 850;\n  letter-spacing: -.025em;\n}\n\n.notif-header p {\n  margin: 5px 0 0;\n  color: #71899b;\n  font-size: .76rem;\n  font-weight: 600;\n}\n\n.notif-close {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  color: #4e7799;\n  border: 1px solid #dce8ee;\n  border-radius: 12px;\n  cursor: pointer;\n  background: #f6fafc;\n  font-size: .95rem;\n  transition: .2s ease;\n}\n\n.notif-close:hover {\n  color: #e95a13;\n  border-color: #ffd1ba;\n  background: #fff3ec;\n  transform: rotate(90deg);\n}\n\n.notif-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 18px 28px;\n  -webkit-overflow-scrolling: touch;\n  margin: 0;\n}\n\n.notif-card {\n  position: relative;\n  overflow: hidden;\n  padding: 16px 42px 15px 17px;\n  margin-bottom: 10px;\n  border: 1px solid #dce8ee;\n  border-radius: 15px;\n  background: #ffffff;\n  box-shadow: 0 8px 18px rgba(30, 63, 88, .045);\n  transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease, background-color .2s ease;\n  cursor: pointer;\n}\n\n.notif-card::before {\n  position: absolute;\n  top: 13px;\n  bottom: 13px;\n  left: 0;\n  width: 3px;\n  content: \"\";\n  border-radius: 0 999px 999px 0;\n  background: #94a9ba;\n}\n\n.notif-card:hover {\n  transform: translateX(-3px);\n  border-color: #b8cfdd;\n  background: #fbfdfe;\n  box-shadow: 0 12px 24px rgba(30, 63, 88, .1);\n}\n\n.notif-card strong {\n  display: block;\n  margin-bottom: 5px;\n  overflow: hidden;\n  color: #29475e;\n  font-size: .86rem;\n  font-weight: 850;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.notif-card p {\n  margin: 0;\n  color: #607b91;\n  font-size: .76rem;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.notif-card small {\n  display: block;\n  margin-top: 8px;\n  color: #94a9ba;\n  font-size: .66rem;\n  font-weight: 650;\n}\n\n.notif-dot {\n  position: absolute;\n  top: 17px;\n  right: 17px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e95a13;\n  box-shadow: 0 0 0 4px #fff1e9;\n}\n\n.notif-card.unread {\n  border-color: #bed9ea;\n  background: #f8fcfe;\n}\n\n.notif-card.unread::before {\n  background: #e95a13;\n}\n\n@media(max-width:768px) {\n  .notif-drawer {\n    width: 100%;\n  }\n\n  .notif-header {\n    padding: 22px 18px 17px;\n  }\n\n  .notif-list {\n    padding: 14px 14px calc(88px + env(safe-area-inset-bottom));\n  }\n}\n\n.notif-bell-wrap {\n  position: relative;\n}\n\n.notif-badge {\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 30px;\n  background: #ef4444;\n  color: white;\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, .35);\n}\n\n\n.notif-clickable {\n  cursor: pointer;\n  transition: .2s;\n}\n\n.notif-clickable:hover {\n  color: var(--primary-200);\n}\n\n\n.notif-skeleton-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.notif-skeleton-item {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  padding: 12px;\n}\n\n.notif-sk-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.notif-sk-content {\n  flex: 1;\n}\n\n.notif-sk-line {\n  width: 100%;\n  height: 14px;\n  border-radius: 20px;\n  margin-bottom: 10px;\n}\n\n.notif-sk-line.short {\n  width: 55%;\n}\n\n.notif-follow-back-btn {\n  margin-top: 10px;\n  border: 1px solid #e95a13;\n  border-radius: 9px;\n  padding: 7px 12px;\n  background: #e95a13;\n  color: white;\n  font-size: .7rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.notif-follow-back-btn:hover {\n  opacity: .92;\n}\n\n/* High-tech CarrerUp application dock */\n.admin-dash-navbar {\n  left: 50%;\n  width: min(1440px, calc(100% - 36px));\n  height: 70px;\n  padding: 0 18px;\n  transform: translateX(-50%);\n  background: rgba(250, 252, 253, .84);\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 18px;\n  box-shadow: 0 16px 38px rgba(30, 63, 88, .11), inset 0 1px rgba(255, 255, 255, .9);\n  backdrop-filter: blur(18px);\n}\n\n.admin-dash-navbar::before {\n  content: \"\";\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: -1px;\n  height: 1px;\n  background: rgba(233, 90, 19, .25);\n}\n\n.admin-dash-navbar-left {\n  gap: 12px;\n  min-width: 330px;\n}\n\n.admin-dash-navbar-logo {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n}\n\n.admin-dash-navbar-search {\n  width: min(300px, 24vw);\n  gap: 10px;\n  padding: 8px 12px;\n  background: rgba(241, 246, 249, .86);\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 12px;\n  transition: .2s;\n}\n\n.admin-dash-navbar-search:focus-within {\n  width: min(345px, 28vw);\n  background: #fff;\n  border-color: rgba(233, 90, 19, .55);\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .08);\n}\n\n.admin-dash-navbar-search input {\n  width: 100%;\n  color: #1d394f;\n  font-size: .84rem;\n}\n\n.admin-dash-navbar-search input::placeholder {\n  color: #7890a2;\n}\n\n.search-clear-icon {\n  color: #e95a13;\n}\n\n.admin-dash-search-dropdown {\n  top: 51px;\n  background: rgba(255, 255, 255, .98);\n  border: 1px solid #e1e9ee;\n  border-radius: 14px;\n  box-shadow: 0 18px 40px rgba(30, 63, 88, .15);\n  overflow: hidden;\n}\n\n.search-item {\n  padding: 12px;\n}\n\n.search-item:hover {\n  background: #fff2eb;\n}\n\n.admin-dash-navbar-center {\n  gap: 9px;\n  padding: 5px;\n  background: rgba(232, 239, 244, .56);\n  border: 1px solid rgba(78, 119, 153, .1);\n  border-radius: 15px;\n}\n\n.admin-dash-nav-icon {\n  min-width: 66px;\n  padding: 7px 8px;\n  border-radius: 11px;\n  color: #71899b;\n  transition: .2s;\n}\n\n.admin-dash-nav-icon svg {\n  font-size: 18px;\n  color: #e95a13;\n\n}\n\n.admin-dash-nav-icon span {\n  margin-top: 2px;\n  font-size: 10px;\n  font-weight: 650;\n}\n\n.admin-dash-nav-icon:hover {\n  color: #e95a13;\n  background: rgba(255, 255, 255, .84);\n}\n\n.admin-dash-nav-icon.active {\n  color: #e95a13;\n  background: #fff;\n  box-shadow: 0 4px 12px rgba(30, 63, 88, .1);\n}\n\n.admin-dash-navbar-right {\n  gap: 10px;\n}\n\n.admin-dash-icon-wrapper {\n  display: grid;\n  place-items: center;\n  min-width: 40px;\n  min-height: 40px;\n  border: 1px solid rgba(78, 119, 153, .14);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, .6);\n}\n\n.admin-dash-icon-wrapper:hover {\n  border-color: rgba(233, 90, 19, .42);\n  background: #fff3ec;\n}\n\n.admin-dash-profile-pic {\n  width: 38px;\n  height: 38px;\n  border: 2px solid #fff;\n  box-shadow: 0 3px 10px rgba(30, 63, 88, .13);\n}\n\n.notif-badge {\n  background: #e95a13;\n}\n\n@media(max-width:944px) {\n  .admin-dash-navbar {\n    left: 10px;\n    right: 10px;\n    width: calc(100% - 20px);\n    transform: none !important;\n  }\n\n}\n\n@media(max-width:768px) {\n  .admin-dash-navbar {\n    top: 8px;\n    right: 10px;\n    left: 10px;\n    width: calc(100% - 20px);\n    height: 62px;\n    padding: 0 10px;\n    border-radius: 15px;\n    gap: 8px;\n    transform: none;\n  }\n\n  .admin-dash-navbar-left {\n    display: flex;\n    flex: 1 1 auto;\n    min-width: 0;\n    gap: 8px;\n  }\n\n  .admin-dash-navbar-logo {\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n  }\n\n  .admin-dash-navbar-search {\n    display: flex;\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n    padding: 7px 9px;\n  }\n\n  .admin-dash-navbar-search:focus-within {\n    width: auto;\n  }\n\n  .admin-dash-navbar-search input {\n    min-width: 0;\n    font-size: .78rem;\n  }\n\n  .admin-dash-navbar-center {\n    display: none;\n  }\n\n  .admin-dash-navbar-right {\n    display: flex;\n    flex: 0 0 auto;\n    gap: 5px;\n  }\n\n  .admin-dash-icon-wrapper {\n    display: grid;\n    place-items: center;\n    min-width: 35px;\n    min-height: 35px;\n    border-radius: 10px;\n  }\n\n  .mobile-bottom-nav {\n    display: flex;\n    position: fixed;\n    top: auto;\n    right: 10px;\n    bottom: 10px;\n    left: 10px;\n    width: calc(100% - 20px);\n    height: 62px;\n    padding: 0 10px;\n    background: rgba(250, 252, 253, .9);\n    border: 1px solid rgba(78, 119, 153, .17);\n    border-radius: 17px;\n    box-shadow: 0 12px 30px rgba(30, 63, 88, .14);\n    backdrop-filter: blur(18px);\n  }\n\n  .mobile-bottom-nav div {\n    display: grid;\n    place-items: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    color: #71899b;\n    transition: .2s ease;\n  }\n\n  .mobile-bottom-nav div.active {\n    color: #e95a13;\n    background: #fff3ec;\n    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);\n  }\n}\n\n/* The mobile dock lives inside the navbar in the current JSX structure. */\n/* @media (max-width: 944px) {\n  .admin-dash-navbar .mobile-bottom-nav {\n    position: absolute !important;\n    top: calc(100vh - 80px) !important;\n    right: auto !important;\n    bottom: auto !important;\n    left: 0 !important;\n    width: calc(100vw - 20px) !important;\n  }\n} */\n\n/* One consistent compact layout for phones and small tablets. */\n@media (max-width: 944px) {\n\n  .mobile-bottom-nav {\n    display: flex;\n    position: fixed;\n    top: auto;\n    right: 10px;\n    bottom: 10px;\n    left: 10px;\n    width: calc(100% - 20px);\n    height: 62px;\n    padding: 0 10px;\n    background: rgba(250, 252, 253, .9);\n    border: 1px solid rgba(78, 119, 153, .17);\n    border-radius: 17px;\n    box-shadow: 0 12px 30px rgba(30, 63, 88, .14);\n    backdrop-filter: blur(18px);\n  }\n\n  .mobile-bottom-nav div {\n    display: grid;\n    place-items: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    color: #71899b;\n    transition: .2s ease;\n  }\n\n  .mobile-bottom-nav div.active {\n    color: #e95a13;\n    background: #fff3ec;\n    box-shadow: inset 0 0 0 1px rgba(233, 90, 19, .14);\n  }\n\n  .admin-dash-navbar {\n    top: 8px;\n    right: 10px;\n    left: 10px;\n    box-sizing: border-box;\n    width: auto;\n    height: 62px;\n    padding: 0 10px;\n    border-radius: 15px;\n    gap: 8px;\n  }\n\n  .admin-dash-navbar-left {\n    display: flex;\n    flex: 1 1 auto;\n    min-width: 0;\n    gap: 8px;\n  }\n\n  .admin-dash-navbar-logo {\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n  }\n\n  .admin-dash-navbar-search {\n    display: flex;\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n    padding: 7px 9px;\n  }\n\n  .admin-dash-navbar-search input {\n    min-width: 0;\n    font-size: .78rem;\n  }\n\n  .admin-dash-navbar-center {\n    display: none;\n  }\n\n  .admin-dash-navbar-right {\n    display: flex;\n    flex: 0 0 auto;\n    gap: 5px;\n  }\n\n  .admin-dash-icon-wrapper {\n    display: grid;\n    place-items: center;\n    min-width: 35px;\n    min-height: 35px;\n    border-radius: 10px;\n  }\n\n  .admin-dash-navbar .mobile-bottom-nav {\n    box-sizing: border-box;\n  }\n}\n\n/* Premium profile menu */\n.admin-dash-dropdown.admin-dash-profile-menu {\n  top: calc(100% + 12px);\n  right: 0;\n  width: 286px;\n  padding: 8px;\n  overflow: hidden;\n  background: rgba(250, 252, 253, .97);\n  border: 1px solid rgba(78, 119, 153, .18);\n  border-radius: 16px;\n  box-shadow: 0 18px 42px rgba(30, 63, 88, .18), inset 0 1px rgba(255, 255, 255, .95);\n  backdrop-filter: blur(18px);\n  animation: profile-menu-in .2s ease-out;\n}\n\n.admin-dash-profile-menu .admin-dash-profile-header {\n  position: relative;\n  min-height: 60px;\n  margin-bottom: 6px;\n  padding: 10px;\n  border: 1px solid rgba(78, 119, 153, .11);\n  border-radius: 12px;\n  background: rgba(241, 246, 249, .76);\n  color: #1d394f;\n  font-weight: 750;\n}\n\n.admin-dash-profile-menu .admin-dash-profile-header::after {\n  content: \"\";\n  position: absolute;\n  top: 13px;\n  left: 40px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  background: #e95a13;\n  box-shadow: 0 0 0 2px rgba(233, 90, 19, .14);\n}\n\n.admin-dash-profile-menu .admin-dash-profile-header img,\n.admin-dash-profile-menu .admin-dash-profile-header>svg {\n  display: grid;\n  place-items: center;\n  width: 36px !important;\n  height: 36px !important;\n  border: 2px solid #fff;\n  border-radius: 11px !important;\n  color: #4e7799;\n  background: #e8eff4;\n  box-shadow: 0 4px 12px rgba(30, 63, 88, .12);\n}\n\n.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header) {\n  min-height: 44px;\n  margin: 2px 0;\n  padding: 9px 10px;\n  border: 1px solid transparent;\n  border-radius: 11px;\n  color: #345269;\n  font-size: .83rem;\n  font-weight: 650;\n  transition: .18s ease;\n}\n\n.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header) svg {\n  display: grid;\n  place-items: center;\n  box-sizing: content-box;\n  width: 17px;\n  height: 17px;\n  padding: 7px;\n  border-radius: 9px;\n  color: #4e7799;\n  background: #edf3f6;\n}\n\n.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header):hover {\n  border-color: rgba(233, 90, 19, .17);\n  background: #fff3ec;\n  color: #d84f0d;\n  transform: translateX(3px);\n}\n\n.admin-dash-profile-menu .admin-dash-profile-item:not(.admin-dash-profile-header):hover svg {\n  color: #e95a13;\n  background: #ffe5d6;\n}\n\n.admin-dash-profile-menu .admin-dash-logout {\n  margin-top: 7px;\n  padding-top: 12px !important;\n  border-top: 1px solid rgba(78, 119, 153, .12) !important;\n  color: #bd3d25 !important;\n}\n\n.admin-dash-profile-menu .admin-dash-logout svg {\n  color: #bd3d25 !important;\n  background: #fff0ed !important;\n}\n\n@keyframes profile-menu-in {\n  from {\n    opacity: 0;\n    transform: translateY(-7px) scale(.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (max-width: 944px) {\n  .admin-dash-dropdown.admin-dash-profile-menu {\n    position: fixed;\n    top: 78px;\n    right: 10px;\n    width: min(286px, calc(100vw - 20px));\n  }\n}\n\n/* Glovo-inspired active navigation icon — final override for both nav variants. */\n.admin-dash-nav-icon > svg {\n  transform-origin: 48% 62%;\n  transition: transform .28s cubic-bezier(.2,.8,.2,1), filter .28s ease, color .28s ease;\n}\n\n.admin-dash-nav-icon.active > svg {\n  color: #e95a13;\n  filter: drop-shadow(0 5px 7px rgba(233, 90, 19, .3));\n  animation: navIconWow .72s cubic-bezier(.18,.89,.32,1.38) both;\n}\n\n.admin-dash-nav-icon.active::before {\n  transform: rotate(-7deg);\n  box-shadow: 0 9px 20px rgba(233,90,19,.25), inset 0 1px rgba(255,255,255,.35);\n}\n\n@media (max-width: 944px) {\n  .mobile-bottom-nav {\n    position: fixed !important;\n    top: auto !important;\n    right: 10px !important;\n    left: 10px !important;\n    width: auto !important;\n    overflow: visible;\n    bottom: calc(\n      max(\n        var(--mobile-browser-inset, 0px),\n        env(safe-area-inset-bottom, 0px)\n      ) + 10px\n    ) !important;\n  }\n\n  .mobile-bottom-nav > div {\n    position: relative;\n    isolation: isolate;\n    overflow: visible;\n  }\n\n  .mobile-bottom-nav > div::before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    width: 43px;\n    height: 43px;\n    border-radius: 14px 17px 13px 17px;\n    opacity: 0;\n    background: linear-gradient(145deg, #f57a3c, #e34e08);\n    box-shadow: 0 11px 23px rgba(233,90,19,.3), inset 0 1px rgba(255,255,255,.42);\n    transform: translateY(5px) rotate(0) scale(.55);\n    transition: opacity .2s ease, transform .45s cubic-bezier(.16,1,.3,1);\n  }\n\n  .mobile-bottom-nav > div::after {\n    content: \"\";\n    position: absolute;\n    z-index: -2;\n    width: 50px;\n    height: 50px;\n    border: 1px solid rgba(233,90,19,.35);\n    border-radius: 17px;\n    opacity: 0;\n    transform: scale(.65) rotate(-8deg);\n  }\n\n  .mobile-bottom-nav > div > svg {\n    position: relative;\n    z-index: 1;\n    transform-origin: 48% 65%;\n    transition: color .25s ease, transform .3s ease, filter .3s ease;\n  }\n\n  .mobile-bottom-nav > div.active {\n    color: #fff !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .mobile-bottom-nav > div.active::before {\n    opacity: 1;\n    transform: translateY(-9px) rotate(-8deg) scale(1);\n    animation: navBadgeFloat 3s ease-in-out .7s infinite;\n  }\n\n  .mobile-bottom-nav > div.active::after {\n    animation: navActiveRipple .85s .12s cubic-bezier(.2,.7,.2,1) both;\n  }\n\n  .mobile-bottom-nav > div.active > svg {\n    color: #fff;\n    filter: drop-shadow(0 5px 7px rgba(125,41,4,.3));\n    animation: navIconWow .72s cubic-bezier(.18,.89,.32,1.38) both;\n  }\n\n  .mobile-bottom-nav > div:not(.active):hover > svg {\n    color: #e95a13;\n    transform: translateY(-2px) rotate(-3deg);\n  }\n}\n\n@keyframes navIconWow {\n  0% { opacity: .35; transform: translateY(8px) rotate(16deg) scale(.58); }\n  46% { transform: translateY(-13px) rotate(-14deg) scale(1.2); }\n  72% { transform: translateY(-8px) rotate(-6deg) scale(.94); }\n  100% { opacity: 1; transform: translateY(-9px) rotate(-9deg) scale(1.06); }\n}\n\n@keyframes navActiveRipple {\n  0% { opacity: .75; transform: translateY(-9px) scale(.65) rotate(-8deg); }\n  100% { opacity: 0; transform: translateY(-9px) scale(1.55) rotate(-2deg); }\n}\n\n@keyframes navBadgeFloat {\n  0%, 100% { transform: translateY(-9px) rotate(-8deg); }\n  50% { transform: translateY(-12px) rotate(-5deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .admin-dash-nav-icon.active > svg,\n  .mobile-bottom-nav > div.active::before,\n  .mobile-bottom-nav > div.active::after,\n  .mobile-bottom-nav > div.active > svg {\n    animation: none !important;\n  }\n}\n\n/* Feed user search: premium discovery list. */\n.admin-dash-navbar-search .admin-dash-search-dropdown {\n  top: calc(100% + 10px);\n  left: 0;\n  width: min(420px, calc(100vw - 48px));\n  max-height: min(420px, calc(100dvh - 120px));\n  padding: 7px;\n  overflow-y: auto;\n  border: 1px solid rgba(78, 119, 153, .18);\n  border-radius: 16px;\n  background: #fbfcfd;\n  box-shadow: 0 20px 44px rgba(30, 63, 88, .18), inset 0 1px #ffffff;\n  scrollbar-width: thin;\n  scrollbar-color: #94a9ba transparent;\n  animation: feed-user-search-in .2s ease both;\n}\n\n.admin-dash-navbar-search .admin-dash-search-dropdown::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 22px;\n  left: 22px;\n  height: 2px;\n  border-radius: 0 0 3px 3px;\n  background: #e95a13;\n}\n\n.admin-dash-navbar-search .search-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 60px;\n  gap: 10px;\n  margin: 0;\n  padding: 9px;\n  border: 1px solid transparent;\n  border-radius: 11px;\n  color: #29475e;\n  background: transparent;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  text-align: left;\n  cursor: pointer;\n  transition: .18s ease;\n}\n\n.admin-dash-navbar-search .search-item:hover {\n  border-color: rgba(233, 90, 19, .2);\n  background: #fff8f4;\n  transform: translateX(2px);\n}\n\n.search-item-avatar {\n  display: grid;\n  flex: 0 0 40px;\n  width: 40px;\n  height: 40px;\n  place-items: center;\n  overflow: hidden;\n  border: 2px solid #ffffff;\n  border-radius: 12px;\n  color: #ffffff;\n  background: #4e7799;\n  box-shadow: 0 4px 10px rgba(78, 119, 153, .18);\n}\n\n.search-item-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 9px;\n  object-fit: cover;\n}\n\n.search-item-avatar svg {\n  font-size: .9rem;\n}\n\n.search-item-content {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.search-item-content strong {\n  overflow: hidden;\n  color: #29475e;\n  font-size: .78rem;\n  font-weight: 850;\n  letter-spacing: -.01em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.search-item-content small {\n  overflow: hidden;\n  color: #71899b;\n  font-size: .66rem;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.search-item-arrow {\n  flex: 0 0 auto;\n  color: #94a9ba;\n  font-size: .72rem;\n  transition: .18s ease;\n}\n\n.search-item:hover .search-item-arrow {\n  color: #e95a13;\n  transform: translateX(2px);\n}\n\n.admin-dash-navbar-search .search-empty,\n.admin-dash-navbar-search .search-loading {\n  margin: 0;\n  padding: 20px 12px;\n  color: #71899b;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: .73rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.admin-dash-navbar-search .search-loading::before {\n  content: \"\";\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  margin-right: 7px;\n  border-radius: 50%;\n  background: #e95a13;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .12);\n  animation: feed-search-pulse 1s ease-in-out infinite alternate;\n}\n\n.admin-dash-navbar-search .search-empty {\n  border: 1px dashed rgba(78, 119, 153, .2);\n  border-radius: 10px;\n}\n\n.admin-dash-navbar-search .search-item:focus-visible {\n  outline: 2px solid #e95a13;\n  outline-offset: 2px;\n}\n\n@keyframes feed-user-search-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(.985);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes feed-search-pulse {\n  from {\n    opacity: .5;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-dash-navbar-search .admin-dash-search-dropdown {\n    position: fixed;\n    top: 78px;\n    right: 10px;\n    left: 10px;\n    width: auto;\n    max-height: min(430px, calc(100dvh - 168px));\n    border-radius: 15px;\n  }\n\n  .admin-dash-navbar-search .search-item {\n    min-height: 58px;\n  }\n}\n\n\n.admin-dash-subscription {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 12px 14px;\n  margin: 6px 8px;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.admin-dash-subscription:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.subscription-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n}\n\n.admin-dash-subscription.free .subscription-icon {\n  background: #f1f3f5;\n  color: #606770;\n}\n\n.admin-dash-subscription.premium .subscription-icon {\n  background: rgba(255, 183, 0, 0.12);\n  color: #e6a400;\n}\n\n.subscription-info {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.subscription-info strong {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.subscription-info span {\n  font-size: 11px;\n  color: #777;\n  margin-top: 2px;\n}\n\n.admin-dash-subscription.premium .subscription-info strong {\n  color: #d99a00;\n}\n\n.subscription-arrow {\n  font-size: 11px;\n  color: #aaa;\n}\n\n.subscription-loading {\n  color: #888;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
